import React from 'react';
import { CommonPrelanderV48 } from '../../components/CommonPrelanderV48';
import { QUIZ_SLIDES_V37 } from '../../shared/quiz-slides/quiz-slides-v37';

function PrelanderV57Page({ initialPrelander }) {
    return (
        <CommonPrelanderV48
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V37}
        />
    );
}

export {
    PrelanderV57Page
};
